import { GetProcessesDocument, GetProcessesQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ProcessDetail } from '../domain'

export enum DueDatesFields {
  ProcessStartDate = 'process_start_date',
  ContractStartDate = 'contract_start_date',
  ContractEndDate = 'contract_end_date',
  EmployeeTerminationDate = 'employee_termination_date',
  StepStartDate = 'step_start_date',
  TrainingCompletionDate = 'training_completion_date',
  ContractTrialEndDate = 'contract_trial_end_date',
}

export interface ProcessesQuery {}
export interface Process extends ProcessDetail {}

export const useProcesses = (variables?: GetProcessesQueryVariables) => {
  const { data, loading, refetch } = useQuery(GetProcessesDocument, { variables })

  return {
    loading,
    refetch,
    processes: data ? (data.processes.processesConnection.nodes as ProcessDetail[]) : [],
  }
}
